import React from 'react';
import { IControlComponentContainerProps } from '../entities';

const ControlComponent = React.memo<IControlComponentContainerProps>(props =>
	props.form.controlMap[props.id].__render(props.children)
);

export { ControlComponent };
